// Heuristics to infer association defaults from parsed lead text
export function inferAssociationTypeFromText(text = '') {
  const t = String(text || '').toLowerCase();
  if (!t) return 'HOA';

  // Count keyword matches to determine most likely type
  const condoScore = (t.match(/condo|condominium|condo owners|coa\b/g) || []).length;
  const hoaScore = (t.match(/\bhoa\b|homeowners|home owner/g) || []).length;

  // If we have clear condo indicators and no HOA indicators, it's COA
  if (condoScore > 0 && hoaScore === 0) return 'COA';

  // If we have clear HOA indicators and no condo indicators, it's HOA
  if (hoaScore > 0 && condoScore === 0) return 'HOA';

  // If we have both, go with the higher score
  if (condoScore > hoaScore) return 'COA';
  if (hoaScore > condoScore) return 'HOA';

  // Check for other specific types
  if (t.includes('town') || t.includes('townhome')) return 'Townhomes';
  if (t.includes('high rise') || t.includes('high-rise') || t.includes('highrise'))
    return 'High Rise';
  if (t.includes('new build')) return 'New Build';

  // Conservative default when unclear
  return 'HOA';
}

// Parse a range like "2-49 units" and return the floor of the midpoint.
// If max is 'more' or unparseable, return the min. Returns null when nothing parseable.
export function inferNumberOfUnitsFromRangeText(text = '') {
  if (!text) return null;
  const t = String(text).replace(/,/g, '').toLowerCase();

  // match patterns like "2-49" or "1 - 25 units"
  const range = t.match(/(\d+)\s*[-–]\s*(\d+|more|more\+|more.*)/i);
  if (range) {
    const min = Number(range[1]);
    const maxRaw = String(range[2]);
    if (!isNaN(min) && /more/.test(maxRaw)) {
      return String(Math.floor(min));
    }
    const max = Number(maxRaw);
    if (!isNaN(min) && !isNaN(max)) {
      return String(Math.floor((min + max) / 2));
    }
  }

  // Handle plus pattern without dash (e.g., "50+ units")
  const plusMatch = t.match(/(\d+)\+/);
  if (plusMatch) {
    return String(Number(plusMatch[1]));
  }

  // single number - return as string for consistency
  const single = t.match(/^(\d+)$/);
  if (single) return single[1];

  return null;
}

export default {
  inferAssociationTypeFromText,
  inferNumberOfUnitsFromRangeText,
};
